
import { Button } from "./Button";

export class ConfirmButton extends Button {
    init() {
        super.init();

        this.includeComponents({
            'ConfirmDeleteModal': "document@#ConfirmDeleteModal",
        });

   

        this.on('click', () => this.onConfirm());
    }

    onConfirm() {
        this.ConfirmDeleteModal.setupForUrlDelete(this.url, this.delete_text ) 
    }


}
